import { ChangeDetectorRef, Component, ElementRef, InjectFlags, Input, Optional, TemplateRef, ViewChild, inject } from '@angular/core';
import { catchError, concatMap, defaultIfEmpty, first, forkJoin,  from,  map,  Observable,  of,  Subject, switchMap, takeUntil, tap } from 'rxjs';
import { ArticleService } from 'src/app/services/article/article.service';
import { Template, GetTemplateResponse, GetAllTemplateResponse, AddOrRemoveAsFavoriteTemplateRequest, AddOrRemoveAsFavoriteTemplateResponse, GetAllTemplateRequest } from 'src/app/_shared/models/article';
import { Router } from '@angular/router';
import { MwcModalService } from 'mwc/modal';
import { GetSettingsFileResponse } from 'src/app/_shared/models/getsettingsfileresponse';
import { ArticleHelperService } from 'src/app/_shared/services/helper/article/article-helper.service';
import { NZ_MODAL_DATA } from 'mwc/modal';
import { GEOData, topicIdea } from 'src/app/_shared/models/topic';
import { GetSettingsFileRequest } from 'src/app/_shared/models/getsettingsfilerequest';
import { StorageHelper } from 'src/app/_utilities/storage-helper';
import { SettingsService } from 'src/app/services/settings/settings.service';
import { UserInfo } from 'src/app/_shared/models/common';
import { CommonService } from 'src/app/services/common/common.service';
import { ContentStudioTrackingService } from 'src/app/_shared/services/tracking/contentstudio-tracking.service';
import { FormControl } from '@angular/forms';
import { CampaignData } from '../../../../../campaigns/view-campaigns/view-campaigns.component';
import { FEATURES } from '../../../../consts/app-constants';
import { WebpageTemplateService } from '../../../../../services/webpageTemplate/webpageTemplate.service';
import { WebpageTemplateRequest } from 'src/app/_shared/models/webpage-template.model';
import { TemplateDetailsModalComponent } from './template-details-modal/template-details-modal.component';


@Component({
  selector: 'app-new-template-selector',
  templateUrl: './new-template-selector.component.html',
  styleUrls: ['./new-template-selector.component.scss']
})
export class NewTemplateSelectorComponent {
  geoTemplates = [1,2,3,9,5,4,12,11,8,13,32];
  @Input() containerHeight = 'calc(100vh - 303px)';
  @ViewChild('templateContainer', { read: ElementRef }) templateContainer;
  tabs = { 'all': true, 'web': false, news: false, social: false, media: false, advertising: false, emails: false };
  templatesCount = {};
  favoritesCount:any;
  templateTypes = ['web', 'news', 'social', 'media', 'advertising', 'emails'];
  isTemplateLoading: boolean = false;
  settings: GetSettingsFileResponse;
  readonly mwcModalData: { topicIdeaData: topicIdea, textTitle: string, campaignData: CampaignData, GEOData:GEOData } = inject(NZ_MODAL_DATA, InjectFlags.Optional);
  _storageHelper: StorageHelper;
  rowedData = [];
  allTemplates = [];
  selectedCard;
  topicData = this.mwcModalData?.topicIdeaData ? this.mwcModalData.topicIdeaData : null;
  textTitle = this.mwcModalData?.textTitle ? this.mwcModalData.textTitle : "";
  //campaignId = this.mwcModalData?.campaignId ? this.mwcModalData.campaignId : "";
  campaignData = this.mwcModalData?.campaignData ? this.mwcModalData.campaignData : null;
  isSaasUser: boolean = false;
  filterBy: string = 'recommended';
  private destroy$: Subject<any> = new Subject();

  searchField: FormControl = new FormControl();
  selectedMenuValue: string = 'All Workflows';
  AllTemplateResponse: GetAllTemplateResponse;
  childTemplateTypes = [];
  childTemplates = [];
  searchTxt: string = '';
  timeout = null;
  openMap: { [name: string]: boolean } = {
    sub1: false,
    sub2: false,
    sub3: false
  };
  noTemplateExist: boolean = false;
  generateModalAIRef: any;  
  showWebPagesCard: boolean = false;
  isCustomTemplatesEnabled: boolean = false;
  isTemplateExistInSettings: boolean = false;
  
  customTemplates: Template[] = [
    {
      templateId: 1001,
      title: 'Homepage',
      description: 'Write 3 detailed steps about how your product or business works.',
      type: 'web',
      icon: 'browser',
      iconColor: 'primary',
      isRecommended: true,
      isFavorite: false,
      recentlyUsed: false,
      whyUse: [
        'Create an engaging first impression for potential guests',
        'Highlight key amenities and features of your property',
        'Drive direct bookings with compelling calls-to-action'
      ],
      summary: 'This template helps you create a professional and engaging hotel homepage that highlights your property\'s unique features, amenities, and value proposition to potential guests.',
      templateCategories: ['Hospitality', 'Hotel', 'Homepage'],
      titleText: 'Hotel Homepage',
      placeholderText: 'Create a compelling homepage for your hotel',
      contentBriefText: 'This template will help you create a professional and engaging hotel homepage.',
      isPublishable: true
    },
    {
      templateId: 1002,
      title: 'Rooms',
      description: 'Write compelling, engaging and informative content that your subscribers will love.',
      type: 'web',
      icon: 'browser',
      iconColor: 'primary',
      isRecommended: true,
      isFavorite: false,
      recentlyUsed: false,
      whyUse: [
        'Highlight room features and amenities in detail',
        'Showcase room categories with compelling descriptions',
        'Drive room upgrades with premium features'
      ],
      summary: 'This template creates detailed and appealing room descriptions that highlight amenities, views, and special features to help guests choose the perfect accommodation for their stay.',
      templateCategories: ['Hospitality', 'Hotel', 'Rooms'],
      titleText: 'Hotel Rooms & Suites',
      placeholderText: 'Describe your hotel rooms and suites',
      contentBriefText: 'This template will help you create detailed and appealing room descriptions.',
      isPublishable: true
    },
    {
      templateId: 1003,
      title: 'Amenities',
      description: 'Write compelling, engaging and informative content that your subscribers will love.',
      type: 'web',
      icon: 'browser',
      iconColor: 'primary',
      isRecommended: false,
      isFavorite: false,
      recentlyUsed: false,
      whyUse: [
        'Showcase unique amenities that differentiate your property',
        'Highlight facilities that enhance the guest experience',
        'Increase ancillary revenue opportunities'
      ],
      summary: 'This template helps you create compelling content that showcases your hotel\'s amenities and facilities, from pools and spas to fitness centers and restaurants.',
      templateCategories: ['Hospitality', 'Hotel', 'Amenities'],
      titleText: 'Hotel Amenities',
      placeholderText: 'Describe your hotel amenities',
      contentBriefText: 'This template will help you highlight your hotel\'s amenities and facilities.',
      isPublishable: true
    },
    {
      templateId: 1004,
      title: 'Local Area',
      description: 'Write 3 detailed steps about how your product or business works.',
      type: 'web',
      icon: 'marker-pin-04',
      iconColor: 'primary',
      isRecommended: false,
      isFavorite: false,
      recentlyUsed: false,
      whyUse: [
        'Position your hotel as a local expert',
        'Enhance guest experience with local recommendations',
        'Increase length of stay with nearby attractions'
      ],
      summary: 'This template helps you create a comprehensive guide to local attractions, dining, shopping, and experiences near your hotel to enhance the guest experience.',
      templateCategories: ['Hospitality', 'Hotel', 'Local Area'],
      titleText: 'Local Area Guide',
      placeholderText: 'Create a guide to local attractions',
      contentBriefText: 'This template will help you create a comprehensive guide to local attractions.',
      isPublishable: true
    },
    {
      templateId: 1005,
      title: 'Meetings & Events',
      description: 'Write compelling, engaging and informative content that your subscribers will love.',
      type: 'web',
      icon: 'calendar',
      iconColor: 'primary',
      isRecommended: false,
      isFavorite: false,
      recentlyUsed: false,
      whyUse: [
        'Showcase meeting room capacities and configurations',
        'Highlight specialized event services and catering',
        'Target group business and corporate clients'
      ],
      summary: 'This template helps you create content that promotes your hotel\'s meeting spaces, event capabilities, and services for conferences, weddings, and special occasions.',
      templateCategories: ['Hospitality', 'Hotel', 'Events'],
      titleText: 'Meetings & Events',
      placeholderText: 'Describe your meeting spaces and event capabilities',
      contentBriefText: 'This template will help you promote your hotel\'s meeting and event facilities.',
      isPublishable: true
    },
    {
      templateId: 1006,
      title: 'Offers',
      description: 'Write compelling, engaging and informative content that your subscribers will love.',
      type: 'web',
      icon: 'sale-02',
      iconColor: 'primary',
      isRecommended: true,
      isFavorite: false,
      recentlyUsed: false,
      whyUse: [
        'Drive direct bookings with exclusive offers',
        'Increase revenue with value-added packages',
        'Target specific segments with tailored promotions'
      ],
      summary: 'This template helps you create compelling offers, packages, and promotions that drive direct bookings and increase revenue across different seasons and segments.',
      templateCategories: ['Hospitality', 'Hotel', 'Offers'],
      titleText: 'Special Offers',
      placeholderText: 'Create special offers and packages',
      contentBriefText: 'This template will help you create compelling offers and promotions.',
      isPublishable: true
    }
  ];
  constructor(
    private tracking: ContentStudioTrackingService,
    private articleService: ArticleService,
    private modalService: MwcModalService,
    private _router: Router,
    private ngChangeDetectorRef: ChangeDetectorRef,
    private articleHelperService: ArticleHelperService,
    private settingsService: SettingsService, private commonService: CommonService, private webpageTemplateService: WebpageTemplateService) {
    this._storageHelper = new StorageHelper();
  }

  onTabSelect(tabName: string) {
    for (let k in this.tabs) {
      this.tabs[k] = false;
    }
    this.tabs[tabName] = true;
    this.rowedData = this.distributeToRows(tabName === 'all' ? this.allTemplates : this.allTemplates.filter(t => t.type === tabName));
    this.templateContainer.nativeElement.scrollTop = 0;
  }

  //getDummyData(count) {
  //  let temp: Template = {
  //    title: 'Blog Article',
  //    description: 'Turn a title and an outline into a fully SEO-optimized and long article with this AI editor.',
  //    isRecommended: true,
  //    iconColor: 'primary',
  //    type: 'web'
  //  };
  //  let colors = ['primary', 'green', 'yellow'];
  //  let type = ['web', 'news', 'social', 'media', 'advertising', 'emails']

  //  let templates = [];

  //  for (let i = 0; i < count; i++) {
  //    templates.push({ ...temp, id: i, 
  //      title: temp.title + i, 
  //      iconColor: colors[Math.floor(Math.random() * 3)],
  //      type: type[Math.floor(Math.random() * 6)],
  //      isRecommended:  !!(Math.floor(Math.random() * 2))
  //    });
  //  }

  //  return templates;
  //}

  distributeToRows(data) {
    let distributed = [];
    let row = [];
    data.forEach((datum, i) => {
      if (i && i % 3 == 0) {
        distributed.push([...row]);
        row = [];
      }
      row.push(datum);
    });
    distributed.push([...row]);
    return distributed;
  }

  onSelect(card) {
    this.selectedCard = card;
  }

  initializeNewArticle(mode: string, templateData: Template) {
    // Track the template usage
    this.tracking.trackEvent(
      'pageview', `Template - ${templateData.title}`
    );

    // For custom templates, open our custom workflow modal instead
    const isCustomTemplate = this.customTemplates.some(t => t.templateId === templateData.templateId) || templateData.type === 'web' && templateData.title === 'Web Pages';
    
    if (templateData.title === 'Web Pages') {
      const geoData = this.mwcModalData?.GEOData;
      const isFromGEO = geoData != null && geoData.isFromGEO;
      // Import the CustomTemplateWorkflowComponent dynamically
      import('../custom-template-workflow/custom-template-workflow-tabset.component').then(module => {
        const customWorkflowRef = this.modalService.create({
          mwcContent: module.CustomTemplateWorkflowTabsetComponent,
          // GEO already knows the topic, keywords and prompts, so hand them to the
          // workflow instead of making the user re-enter what the recommendation carried.
          mwcData: {
            template: templateData,
            ...(isFromGEO ? {
              campaignName: this.topicData?.pillarIdea || '',
              keywords: this.topicData?.keywords || [],
              prompts: geoData.prompts || []
            } : {})
          },
          mwcWidth: '1200px',
          mwcCentered: true,
          mwcClassName: 'custom-template-workflow-modal',
          mwcFooter: null,
          mwcBodyStyle: {'padding' : '0'},
          mwcClosable: false
        });
        
        // Handle the result when the modal is closed
        customWorkflowRef.afterClose.subscribe(result => {
          if (result) {
            // If we have a result, proceed with article creation using the workflow data
            console.log('Custom template workflow data:', result);
            
            // Now open the regular article creation flow with the collected data
            this.generateModalAIRef = this.articleHelperService.createnewpost(
              'AI',
              this._router,
              this.modalService,
              this.settings,
              this.topicData,
              templateData,
              result.pageTitle, // Use the title from the workflow
              this.campaignData,
              false,
              false,
              false,
              isFromGEO ? geoData.geoRecommendationId : null,
              isFromGEO ? (geoData.prompts || []) : [],
              isFromGEO ? geoData.languageId : null
            );
          }
        });
      });
      return;
    }
    
    if (templateData.templateId === 0) {
      mode = 'mannual';
    }
    
    // Open the template creation dialog
    this.generateModalAIRef = this.articleHelperService.createnewpost(
      mode, 
      this._router, 
      this.modalService, 
      this.settings, 
      this.topicData, 
      templateData, 
      this.textTitle, 
      this.campaignData,
      false,
      false,
      false,
      this.mwcModalData?.GEOData?.isFromGEO ? this.mwcModalData.GEOData.geoRecommendationId : null,
      this.mwcModalData?.GEOData?.isFromGEO ? (this.mwcModalData.GEOData.prompts || []) : [],
      this.mwcModalData?.GEOData?.isFromGEO ? this.mwcModalData.GEOData.languageId : null,
    );
  }

  //getTemplates() {
  //  of(this.getDummyData(178)).subscribe(templates => {
  //    this.allTemplates = [...templates];
  //    this.templatesCount['all'] = this.allTemplates.length;
  //    this.templateTypes.forEach(type => {
  //      this.templatesCount[type] = this.allTemplates.filter(t => t.type === type).length;
  //    });
  //    this.selectedCard = templates[0];
  //    this.rowedData = this.distributeToRows([...templates]);
  //  });
  //}

  getTemplatesAndSettings() {
    this.isTemplateLoading = true;
    const getTemplatesRequest = this.articleService.GetTemplateList<GetTemplateResponse>();
    let getSettingsFileRequest = new GetSettingsFileRequest();
    getSettingsFileRequest.ProfileId = this._storageHelper.user.pId;
    const getSettingsRequest = this.settingsService.getSettings<GetSettingsFileRequest>(getSettingsFileRequest);
    forkJoin({
      templatesResponse: getTemplatesRequest,
      settingsResponse: getSettingsRequest
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ templatesResponse, settingsResponse }) => {
        this.isTemplateLoading = false;
        if (templatesResponse) {
          this.allTemplates = [...templatesResponse.templates];
          this.templatesCount['all'] = templatesResponse.totalRecords;
          this.templateTypes.forEach(type => {
            this.templatesCount[type] = this.allTemplates.filter(t => t.type === type).length;
          });
          //this.selectedCard = templatesResponse.templates[0];
          this.rowedData = this.distributeToRows([...templatesResponse.templates]);
        }
        if (settingsResponse) {
          this.settings = settingsResponse;
        }
        this.ngChangeDetectorRef.detectChanges();
      });
  }

  getAllTemplatesAndSettings() {
    this.isTemplateLoading = true;
    this.AllTemplateResponse = new GetAllTemplateResponse();
    let req = new GetAllTemplateRequest();
    req.IsForCampaign = this.campaignData ? true : false;
    const getTemplatesRequest = this.articleService.GetAllTemplate<GetAllTemplateResponse>(req);
    let getSettingsFileRequest = new GetSettingsFileRequest();
    getSettingsFileRequest.ProfileId = this._storageHelper.user.pId;
    const getSettingsRequest = this.settingsService.getSettings<GetSettingsFileRequest>(getSettingsFileRequest);
    const getTemplateExistFlag$ = this.getTemplatesFromSettings();
    forkJoin({
      templatesResponse: getTemplatesRequest,
      settingsResponse: getSettingsRequest,
      isTemplateExistInSettings: getTemplateExistFlag$
    })
      .pipe(takeUntil(this.destroy$))
      .subscribe(({ templatesResponse, settingsResponse, isTemplateExistInSettings }) => {
        this.isTemplateLoading = false;
        this.isTemplateExistInSettings = isTemplateExistInSettings;
        if (templatesResponse) {
          const isFromGEO = this.mwcModalData.GEOData != null && this.mwcModalData.GEOData.isFromGEO;
          if(this.topicData != null && !isFromGEO){
            templatesResponse.templatesHierarchyList = this.removeTemplatesByIds(templatesResponse.templatesHierarchyList,[30,32]);
          }
          this.AllTemplateResponse = templatesResponse;
          if (req.IsForCampaign) {
            if (this.isSaasUser || !this.isCustomTemplatesEnabled || !this.isTemplateExistInSettings || this._router.url.includes('/campaigns/view-campaigns?')) {
              templatesResponse.templatesHierarchyList = this.removeTemplatesByIds(templatesResponse.templatesHierarchyList,[30,32]);
              this.allTemplates = [...templatesResponse.templatesHierarchyList.filter(t => t.templateTypeName == "All Templates")[0].templates].filter(template => template.templateId != 30 && template.templateId != 32).map(template => ({
                ...template,
                selected: false
              }));
            } else {
              templatesResponse.templatesHierarchyList = this.removeTemplatesByIds(templatesResponse.templatesHierarchyList,[30]);
              this.allTemplates = [...templatesResponse.templatesHierarchyList.filter(t => t.templateTypeName == "All Templates")[0].templates].filter(template => template.templateId != 30).map(template => ({
                ...template,
                selected: false
              }));
            }
          } else {
            // GEO decides its own exclusions below, so don't strip 32 out from under it.
            if (!isFromGEO && (this.isSaasUser || !this.isCustomTemplatesEnabled || !this.isTemplateExistInSettings)) {
              templatesResponse.templatesHierarchyList = this.removeTemplatesByIds(templatesResponse.templatesHierarchyList,[32]);
              this.allTemplates = [...templatesResponse.templatesHierarchyList.filter(t => t.templateTypeName == "All Templates")[0].templates].filter(template => template.templateId != 32);
            } else {
              this.allTemplates = [...templatesResponse.templatesHierarchyList.filter(t => t.templateTypeName == "All Templates")[0].templates];
            }
          }

          if (isFromGEO) {
            templatesResponse.templatesHierarchyList = this.removeTemplatesByIds(templatesResponse.templatesHierarchyList, [0,30]);
            this.allTemplates = [...templatesResponse.templatesHierarchyList.filter(t => t.templateTypeName == "All Templates")[0].templates];

            this.reorderTemplatesForGEO();

            const targetTemplate = this.allTemplates.find(t => t.templateId === this.mwcModalData.GEOData.GEORecommendedTemplateId);
            if (targetTemplate) {
              targetTemplate.isRecommended = true;
            }
          }
          this.templatesCount['all'] = this.allTemplates.length;
          this.templateTypes.forEach(type => {
            this.templatesCount[type] = this.allTemplates.filter(t => t.type === type).length;
          });
          this.updateFavoritesCount(templatesResponse.templatesHierarchyList);
          this.rowedData = this.distributeToRows([...this.allTemplates]);
          this.childTemplates = this.allTemplates;
        }
        if (settingsResponse) {
          this.settings = settingsResponse;
        }
        this.ngChangeDetectorRef.detectChanges();
      });
  }

  private reorderTemplatesForGEO(allTemplatesReorder: boolean = true) {
    // The template GEO actually recommended leads, then the fixed geoTemplates order.
    // Without this the recommendation only gets a badge and still sits wherever the
    // static list happens to put it - or last, if it is not in that list at all.
    const recommendedId = this.mwcModalData?.GEOData?.GEORecommendedTemplateId;
    const orderedIds = (recommendedId != null)
      ? [recommendedId, ...this.geoTemplates.filter(id => id !== recommendedId)]
      : this.geoTemplates;

    if (allTemplatesReorder) {

      const templateMap = new Map(this.allTemplates.map(t => [t.templateId, t]));

      const reorderedTemplates: typeof this.allTemplates = [];

      // 1. Add templates in the specified geoTemplates order
      for (const id of orderedIds) {
        const template = templateMap.get(id);
        if (template) {
          reorderedTemplates.push(template);
          templateMap.delete(id); // Mark as used
        }
      }

      // 2. Add the remaining templates (those not in geoTemplates) in their original order
      for (const template of this.allTemplates) {
        if (templateMap.has(template.templateId)) {
          reorderedTemplates.push(template);
        }
      }

      // Assign back
      this.allTemplates = reorderedTemplates;
    } else {
      const templateMap = new Map(this.childTemplates.map(t => [t.templateId, t]));

      const reorderedTemplates: typeof this.childTemplates = [];

      // 1. Add templates in the specified geoTemplates order
      for (const id of orderedIds) {
        const template = templateMap.get(id);
        if (template) {
          reorderedTemplates.push(template);
          templateMap.delete(id); // Mark as used
        }
      }

      // 2. Add the remaining templates (those not in geoTemplates) in their original order
      for (const template of this.childTemplates) {
        if (templateMap.has(template.templateId)) {
          reorderedTemplates.push(template);
        }
      }

      // Assign back
      this.childTemplates = reorderedTemplates;
    }
    }

  removeTemplatesByIds(data, targetIds) {
    const idSet = new Set(targetIds);
    const filterTemplates = (templates) =>
      templates.filter((t) => !idSet.has(t.templateId));
    const processChildTypes = (childTemplateTypes) =>
      childTemplateTypes.map((child) => ({
        ...child,
        templates: filterTemplates(child.templates),
        childTemplateTypes: processChildTypes(child.childTemplateTypes),
      }));
    return data.map((data) => ({
      ...data,
      templates: filterTemplates(data.templates),
      childTemplateTypes: processChildTypes(data.childTemplateTypes),
    }));
  }

  AddOrRemoveAsFav(TemplateId: number) {
    this.isTemplateLoading = true;
    let request = new AddOrRemoveAsFavoriteTemplateRequest();
    request.templateId = TemplateId;
    this.articleService.AddOrRemoveAsFavoriteTemplate<AddOrRemoveAsFavoriteTemplateResponse>(request)
      .subscribe((response: AddOrRemoveAsFavoriteTemplateResponse) => {
        if (response != null && response.errorCode == 0) {
          if (response.success) {
            if (this.selectedMenuValue == 'All Templates' || this.selectedMenuValue == 'All Workflows') {
              this.getAllTemplatesAndSettings();
            }
            else {
              let req = new GetAllTemplateRequest();
              req.IsForCampaign = this.campaignData ? true : false;
              this.articleService.GetAllTemplate<GetAllTemplateResponse>(req).subscribe((response: GetAllTemplateResponse) => {
                if (response != null && response.errorCode == 0) {
                  this.AllTemplateResponse = response;
                  this.updateFavoritesCount(response.templatesHierarchyList);
                  this.getAllChildTemplates(this.selectedMenuValue);
                  this.isTemplateLoading = false;
                }
              });
            }
          }
        }
        this.ngChangeDetectorRef.detectChanges();
      }, (error) => {
        this.isTemplateLoading = false;
        this.ngChangeDetectorRef.detectChanges();
      });
  }

  getAllChildTemplateTypes(TemplateTypeName: string) {
    if (this.AllTemplateResponse) {
      this.childTemplateTypes = [...this.AllTemplateResponse.templatesHierarchyList.filter(t => t.templateTypeName == TemplateTypeName)[0].childTemplateTypes];
    }
  }
  getAllChildTemplates(TemplateTypeName: string) {
    if (this.AllTemplateResponse) {
      const result = this.findChildTemplates(this.AllTemplateResponse.templatesHierarchyList, TemplateTypeName);
      if (this.campaignData) {
        this.childTemplates = result[0].templates.filter(template => template.templateId != 30);
      }
      else {
        this.childTemplates = result[0].templates;
      }

      if (this.mwcModalData.GEOData != null && this.mwcModalData.GEOData.isFromGEO) {
        this.childTemplates = result[0].templates.filter(template => template.templateId != 0 && template.templateId != 30);
        this.reorderTemplatesForGEO(false);
      }

      const isGeoRecommended =
        this.mwcModalData?.GEOData?.isFromGEO &&
        this.filterBy === 'recommended' && TemplateTypeName == "All Templates";

      if (!isGeoRecommended) {
        this.changeFilterBy(this.filterBy);
      } else {
        this.changeFilterBy("recently-used");
      }
      this.noTemplateExist = false;
    }
  }

  updateFavoritesCount(hierarchyList: any[]) {
    const favoritesNode = this.findChildTemplates(hierarchyList, 'Favorites');
    this.favoritesCount = favoritesNode[0]?.templates?.length || 0;
  }

  findChildTemplates(hierarchyList, templateTypeName) {
    const result = [];
    function recursiveSearch(hierarchy) {
      hierarchy.forEach(item => {
        if (item.templateTypeName === templateTypeName) {
          result.push(item);
        }
        if (item.childTemplateTypes && item.childTemplateTypes.length > 0) {
          recursiveSearch(item.childTemplateTypes);
        }
      });
    }

    recursiveSearch(hierarchyList);
    return result;
  }

  searchTemplatesByTitle(searchText: string = "") {
    const query = searchText.toLowerCase();
    const filteredTemplates = this.childTemplates.filter(template => template.title.toLowerCase().includes(query));
    if (filteredTemplates.length == 0) {
      this.noTemplateExist = true;
    }
    else {
      this.noTemplateExist = false;
    }
    this.rowedData = this.distributeToRows([...filteredTemplates]);
    this.ngChangeDetectorRef.detectChanges();
  }

  triggerSearch() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.searchTemplatesByTitle(this.searchTxt);
    }, 1000);
  }

  LandingPageCustomTemplateAllowedBusinessIds = ['13119'];
  landingPageCustomEnabled = false;
  ngOnInit() {
    this.landingPageCustomEnabled = this.LandingPageCustomTemplateAllowedBusinessIds.includes(this._storageHelper.user.bId);
    //this.getTemplatesAndSettings();
    // Always show custom templates regardless of business ID    
    this.getAllTemplatesAndSettings();
    this.commonService.getUserInfoValue().subscribe((res: UserInfo) => {
      if (res != null) {
        this.isSaasUser = res.isSaasUser;
        this.isCustomTemplatesEnabled = res.featureIds.includes(FEATURES.CustomTemplatesFeatureName);
      }
    });

    this.articleHelperService.OpenTemplateChange.subscribe(() => {
      if (this.generateModalAIRef) {
        this.generateModalAIRef.close();
      }
    });
    
    // Add the new-template-selector-modal class to the parent modal for targeting
    setTimeout(() => {
      // Find the parent modal - try different selectors to ensure we find it
      const modalElement = document.querySelector('.ant-modal-content')?.closest('.ant-modal') || 
                          document.querySelector('.ant-modal') || 
                          document.querySelector('.mwc-modal');
      
      if (modalElement) {
        modalElement.classList.add('new-template-selector-modal');
      }
    }, 100);
  }
  menuEvent(value) {
    const menuItemEl: HTMLElement = value.cdr._cdRefInjectingView[0];
    const labelEl: HTMLElement | null = menuItemEl.querySelector('.menu-item-label');
    this.selectedMenuValue = (labelEl ? labelEl.innerText : menuItemEl.innerText).trim();
    this.showWebPagesCard = false; // Reset by default
    
    if (this.selectedMenuValue == "All Workflows") {
      this.getAllChildTemplates("All Templates");
      // Reset modal class for normal width
      document.querySelector('.new-template-selector-modal')?.classList.remove('custom-templates-modal');
      if (this.containerHeight && this.templateContainer) {
        this.templateContainer.nativeElement.style.height = this.containerHeight;
      }
    } 
    // else if (this.selectedMenuValue == "Custom Templates") {
    //   // Show web pages card for Custom Templates section
    //   this.showWebPagesCard = true;
    //   // Show hotel-related templates
    //   this.childTemplates = [...this.customTemplates];
    //   this.rowedData = this.distributeToRows([...this.childTemplates]);
    //   this.noTemplateExist = false;
    //   this.isViewDetails = false;
      
    //   // Apply custom width class to modal
    //   document.querySelector('.new-template-selector-modal')?.classList.add('custom-templates-modal');
    //   if (this.containerHeight && this.templateContainer) {
    //     // Adjust height to account for the Web Pages card (300px)
    //     let adjustedHeight = 'calc(' + this.containerHeight + ' - 300px)';
    //     this.templateContainer.nativeElement.style.height = adjustedHeight;
    //   }
    // }
    else {
      this.getAllChildTemplates(this.selectedMenuValue);
      // Reset modal class for normal width
      document.querySelector('.new-template-selector-modal')?.classList.remove('custom-templates-modal');
      if (this.containerHeight && this.templateContainer) {
        this.templateContainer.nativeElement.style.height = this.containerHeight;
      }
    }
  }

  changeFilterBy(value: string) {
    const originalOrder = [...this.childTemplates];
    this.filterBy = value;
    if (this.filterBy == "recently-used") {
      const recentlyUsedTemplates = this.childTemplates.filter(t => t.recentlyUsed == true);
      this.rowedData = this.distributeToRows([...recentlyUsedTemplates]);
      // If no recently used templates found, show a message
      this.noTemplateExist = recentlyUsedTemplates.length === 0;
    }
    else if (this.filterBy == "alphabetical-order") {
      const alphabeticalTemplates = this.childTemplates.sort((a, b) => a.title.localeCompare(b.title));
      this.rowedData = this.distributeToRows([...alphabeticalTemplates]);
      this.childTemplates = [...originalOrder];
      this.noTemplateExist = false;
    }
    else if (this.filterBy == "recommended") {
      const recommendedTemplates = this.childTemplates.filter(t => t.isRecommended == true);
      if (recommendedTemplates.length > 0) {
        this.rowedData = this.distributeToRows([...recommendedTemplates]);
        this.noTemplateExist = false;
      } else {
        this.rowedData = this.distributeToRows([...originalOrder]);
        this.noTemplateExist = false;
      }
    }
    else {
      this.rowedData = this.distributeToRows([...originalOrder]);
      this.noTemplateExist = false;
    }
    this.ngChangeDetectorRef.detectChanges();
  }
  viewDetailsEvent(data: Template) {
    const detailsRef = this.modalService.create({
      mwcData: { template: data },
      mwcContent: TemplateDetailsModalComponent,
      mwcWidth: '1200px',
      mwcCentered: true,
      mwcClosable: false,
      mwcTitle: null,
      mwcFooter: null,
      mwcBodyStyle: { padding: '0' },
      mwcMaskClosable: true
    });

    detailsRef.afterClose.subscribe((result: { action: string, template: Template, favoriteChanged: boolean }) => {
      if (result?.favoriteChanged) {
        if (this.selectedMenuValue == 'All Templates' || this.selectedMenuValue == 'All Workflows') {
          this.getAllTemplatesAndSettings();
        } else {
          this.getAllChildTemplates(this.selectedMenuValue);
        }
      }
      if (result?.action === 'start') {
        this.initializeNewArticle('AI', result.template);
      }
    });
  }
  openWebPagesWorkflow() {
    // Create a template object for the web pages workflow
    const webPagesTemplate: Template = {
      templateId: 2001, // Using a unique ID for this special template
      title: 'Web Pages',
      description: 'Webpage content generation made easy. Generate content for your entire website and all it\'s pages through a single workflow.',
      type: 'web',
      icon: 'browser',
      iconColor: 'primary',
      isRecommended: true,
      isFavorite: false,
      recentlyUsed: false,
      whyUse: [
        'Generate content for multiple webpages at once',
        'Maintain consistent branding across all pages',
        'Save time with streamlined workflow'
      ],
      summary: 'This template helps you create content for multiple webpages at once using a streamlined workflow.',
      templateCategories: ['Web', 'Multi-page', 'Website'],
      titleText: 'Web Pages',
      placeholderText: 'Create content for your website pages',
      contentBriefText: 'This template will help you generate content for your entire website.',
      isPublishable: true
    };
    
    // Call the same initialization method as regular templates
    this.initializeNewArticle('AI', webPagesTemplate);
  }
  
  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }
  getTemplatesFromSettings(): Observable<boolean> {
    const profileId = this._storageHelper.user.pId;
    const BATCH_SIZE = 5;
    return this.webpageTemplateService.GetProfileBrands({ profileId }).pipe(
      switchMap(brandRes => {
        const brands = brandRes.brands ?? [];
        if (brands.length === 0) {
          this.isTemplateExistInSettings = false;
          return of(false);
        }
        const batches: typeof brands[] = [];
        for (let i = 0; i < brands.length; i += BATCH_SIZE) {
          batches.push(brands.slice(i, i + BATCH_SIZE));
        }
        return from(batches).pipe(
          concatMap(batch => {
            const templateChecks$: Observable<boolean>[] = batch.map(brand =>
              this.webpageTemplateService.getTemplates({ profileId, brandId: brand.id }).pipe(
                map(res => !!(res.success && res.templates?.length)),
                catchError(() => of(false))
              )
            );
            return forkJoin(templateChecks$).pipe(
              map((results: boolean[]) => results.some(Boolean))
            );
          }),
          first(hasTemplates => hasTemplates === true),
          defaultIfEmpty(false),
          tap(result => {
            this.isTemplateExistInSettings = result as boolean;
          })
        );
      }),
      catchError(err => {
        console.error("Brand loading failed", err);
        this.isTemplateExistInSettings = false;
        return of(false);
      })
    );
  }
  
  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
